import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { ptBR } from 'date-fns/locale/pt-BR';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './DateTimeInput.module.css';

registerLocale('pt-BR', ptBR);

interface DateTimeInputProps {
  value: string; // ISO format: YYYY-MM-DDTHH:mm
  onChange: (value: string) => void;
  required?: boolean;
}

const DateTimeInput: React.FC<DateTimeInputProps> = ({ value, onChange, required }) => {
  const parsed = value ? new Date(value) : null;

  const handleChange = (date: Date | null) => {
    if (!date) { onChange(''); return; }
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    onChange(`${y}-${m}-${d}T${h}:${min}`);
  };

  return (
    <div className={styles.wrapper}>
      <DatePicker
        selected={parsed}
        onChange={handleChange}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        timeCaption="Hora"
        dateFormat="dd/MM/yyyy HH:mm"
        locale="pt-BR"
        placeholderText="dd/mm/aaaa hh:mm"
        required={required}
        className={styles.input}
        calendarClassName={styles.calendar}
        wrapperClassName={styles.pickerWrapper}
      />
    </div>
  );
};

export default DateTimeInput;
